import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const PageTitle = styled(Typography)({
  fontSize: '1.3rem',
  marginBottom: '20px',
})
